import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { useTestIdAttribute } from '../../hooks/useTestIdAttribute';
import { useCardStyle } from './useCardStyle';
const StyledCardContainer = styled('div', (p) => p.$style);
export const CardContainer = ({ children, cardVariant, fullWidth, backgroundColorOverride, borderRadiusOverride, testId, overflow, fullHeight, center, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const style = useCardStyle({
        cardVariant,
        fullWidth,
        backgroundColorOverride,
        borderRadiusOverride,
        overflow,
        fullHeight,
        center,
    });
    return (_jsx(StyledCardContainer, { $style: style, ...testIdAttribute, children: children }));
};
